import { Injectable } from '@angular/core';
import * as d3 from 'd3';
import * as turf from '@turf/turf';
import { Feature, FeatureCollection, Geometry, LineString, Point, Polygon } from 'geojson';
import { MathAux } from '../math-aux/math-aux';

@Injectable({
  providedIn: 'root'
})
export class GeojsonAuxService {

  constructor() { }

  getFeaturesInsidePolygon(highways: Feature<LineString>[],polygon:Feature<Polygon>):Feature<LineString>[]{
    let localHighways:Feature<LineString>[] = [];
    highways.forEach(highway=>{
      if (turf.booleanPointInPolygon(highway.geometry.coordinates[1] as [number,number], polygon)){
          localHighways.push(highway)
      }
    })
    return localHighways;
  }

  getGridsInsidePolygon(grid:FeatureCollection<Point>,polygon:Feature<Polygon>):Feature<Geometry>[]{
    let features:Feature<Geometry>[] = [];
    grid.features.forEach( (val,index)=>{
        if (turf.booleanPointInPolygon(val.geometry.coordinates as [number, number], polygon)){
          features.push(val)
        }
      })
    return features
  }


}
